import React from 'react'
import _ from 'lodash'
import { formatToBRL } from 'brazilian-values'
import { useTheme } from '@material-ui/styles'

import ProcessAccordion from '../ProcessAccordion'
import { renderCheckService } from '../utilsFunctions'

const CreditPersonRestrictions = ({ service }) => {
  const theme = useTheme()

  const elemCheck = renderCheckService(service, theme)
  if (elemCheck !== null) return elemCheck

  if (!_.get(service, 'data.consists')) {
    return <strong style={{ color: theme.palette.primary.green }}>Não</strong>
  }

  const restrictionsData = _.get(service, 'data.credit_restrictions_data')

  const formatBRL = (val) => {
    const newValue = _.isString(val) ? val.replace(',', '.') : val
    return formatToBRL(newValue)
  }

  const renderListItem = (title, value) => (
    <li>
      <span style={{ fontWeight: 'bold' }}>{`${title}: `}</span>
      <span>{value}</span>
    </li>
  )

  const renderProtestsAccordion = (protests) => {
    if (_.isEmpty(protests)) return null

    const quantityOccurrences = protests.quantity_occurrences
    const totalValue = protests.total_value

    if (_.parseInt(quantityOccurrences) === 0) return null

    return (
      <ProcessAccordion title="Protestos">
        <ul style={{ listStyle: 'none', padding: 0, fontSize: '1.4rem' }}>
          {renderListItem('Valor Total', formatBRL(totalValue))}
          {renderListItem('Ocorrências', quantityOccurrences)}
        </ul>
      </ProcessAccordion>
    )
  }

  const renderFinancialPendingAccordion = (financialPending) => {
    if (_.isEmpty(financialPending)) return null

    const quantityOccurrences = financialPending.quantity_occurrences
    const totalValue = financialPending.total_value

    if (_.parseInt(quantityOccurrences) === 0) return null

    return (
      <ProcessAccordion title="Pendências Financeiras">
        <ul style={{ listStyle: 'none', padding: 0, fontSize: '1.4rem' }}>
          {renderListItem('Valor Total', formatBRL(totalValue))}
          {renderListItem('Ocorrências', quantityOccurrences)}
        </ul>
      </ProcessAccordion>
    )
  }

  const renderBacenBadCheckAccordion = (bacenBadCheck) => {
    if (_.isEmpty(bacenBadCheck)) return null

    const quantityOccurrences = bacenBadCheck.quantity_occurrences

    if (_.parseInt(quantityOccurrences) === 0) return null

    return (
      <ProcessAccordion title="Bacen Cheque Sem Fundo">
        <ul style={{ listStyle: 'none', padding: 0, fontSize: '1.4rem' }}>
          {renderListItem('Ocorrências', quantityOccurrences)}
        </ul>
      </ProcessAccordion>
    )
  }

  const renderCadinAccordion = (cadin) => {
    if (_.isEmpty(cadin)) return null

    const quantityOccurrences = cadin.quantity_occurrences

    if (_.parseInt(quantityOccurrences) === 0) return null

    return (
      <ProcessAccordion title="Cadin">
        <ul style={{ listStyle: 'none', padding: 0, fontSize: '1.4rem' }}>
          {renderListItem('Ocorrências', quantityOccurrences)}
        </ul>
      </ProcessAccordion>
    )
  }

  return (
    <React.Fragment>
      <strong style={{ color: theme.palette.primary.red }}>Sim</strong>
      <div style={{ marginTop: 30, marginLeft: 30 }}>
        {renderProtestsAccordion(restrictionsData.synthetic_protest)}
        {renderFinancialPendingAccordion(restrictionsData.financial_pending)}
        {renderBacenBadCheckAccordion(restrictionsData.bacen_bad_check)}
        {renderCadinAccordion(restrictionsData.cadin)}
      </div>
    </React.Fragment>
  )
}

export default CreditPersonRestrictions
